import {
  ButtonFonts,
  ButtonGroup,
  ButtonGroupColumnGap,
  ButtonGroupJustifyContent,
  ButtonGroupMargins,
  INDENTS,
  LayoutBlockAuth,
  PrimaryLoginButton,
  SecondaryFontButton1Button,
  TextBlock,
  TextBlockAlignItems,
  TextBlockRowGap,
  TextBoxCaption2Accent,
  TextBoxHeadline2,
  TextDecoration,
} from '@setplex/arcana'
import { useUnit } from 'effector-react'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'
import {
  $pendingSignOut,
  $pendingTryAgain,
  $portalUrl,
  openSubscribersPortal,
  signOut,
  tryAgain,
} from '../model'
import { AppTitle } from '~/shared/ui/components/AppTitle'

export function Title(): JSX.Element {
  return <AppTitle t='expired_subscription' />
}

ExpiredPage.displayName = 'ExpiredPage'
export function ExpiredPage(): JSX.Element {
  const { t } = useTranslation()

  const onSignOut = useUnit(signOut)
  const onTryAgain = useUnit(tryAgain)
  const onOpenSubscribersPortal = useUnit(openSubscribersPortal)

  const portalUrl = useUnit($portalUrl)
  const pendingTryAgain = useUnit($pendingTryAgain)
  const pendingSignOut = useUnit($pendingSignOut)
  const pending = pendingTryAgain || pendingSignOut

  return (
    <LayoutBlockAuth>
      <TextBlock
        alignItems={TextBlockAlignItems.Center}
        rowGap={TextBlockRowGap.INDENT_20}
      >
        <TextBoxHeadline2 title={t('inactive_subscription_label')} />
        <a
          href={portalUrl}
          target='_blank'
          rel='noreferrer'
          onClick={(e) => {
            e.preventDefault()
            onOpenSubscribersPortal()
          }}
        >
          <TextBoxCaption2Accent
            title={t('inactive_subscription_redirect_link')}
            textDecoration={TextDecoration.Underline}
          />
        </a>
      </TextBlock>
      <ButtonGroup
        justifyContent={ButtonGroupJustifyContent.Center}
        width={100}
        wrap={true}
        margins={ButtonGroupMargins.SIZE_100}
        columnGap={ButtonGroupColumnGap.INDENT_30}
      >
        <PrimaryLoginButton
          title={pendingTryAgain ? ' ' : t('try_again')}
          font={ButtonFonts.Button1}
          paddings={[INDENTS.INDENT_30]}
          onClick={onTryAgain}
          disabled={pending}
          isLoading={pendingTryAgain}
        />
        <SecondaryFontButton1Button
          title={pendingSignOut ? ' ' : t('log_out')}
          paddings={[INDENTS.INDENT_30]}
          onClick={onSignOut}
          disabled={pending}
          isLoading={pendingSignOut}
        />
      </ButtonGroup>
    </LayoutBlockAuth>
  )
}
